import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";

import { ElrsService } from "../../services/elrsService";
import { PageHeader } from "../components/ApplicationShell";
import ResponsiveDataTable from "../components/ResponsiveDataTable";

const formatDate = (value) => value && moment(value).isValid() ? moment(value).format("D MMM YYYY, HH:mm") : "Not specified";
const ActiveElrs = () => {
  const [elrs, setElrs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const requestIdRef = useRef(0);

  const loadElrs = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError("");
    try {
      const response = await ElrsService.getActiveElrs();
      if (requestId === requestIdRef.current) setElrs(Array.isArray(response) ? response : response?.data || []);
    } catch (requestError) {
      if (requestId === requestIdRef.current) setError(requestError?.message || "ELRs could not be loaded.");
    } finally {
      if (requestId === requestIdRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadElrs();
    return () => { requestIdRef.current += 1; };
  }, [loadElrs]);

  const columns = useMemo(() => [
    { key: "elr", header: "ELR", filter: { type: "text" } },
    { key: "label", header: "Label", accessor: (item) => item.label || item.elr || "Not specified", filter: { type: "text" } },
    { key: "start_miles", header: "Start mileage", accessor: (item) => item.start_miles || item.boundaries?.start?.milesYards || "Not specified" },
    { key: "end_miles", header: "End mileage", accessor: (item) => item.end_miles || item.boundaries?.end?.milesYards || "Not specified" },
    { key: "updated_at", header: "Last updated", accessor: (item) => formatDate(item.updated_at), sortValue: (item) => item.updated_at },
  ], []);

  return (<>
    <PageHeader description="Reference mileage boundaries available when defining lines at site." title="ELRs" />
    <ResponsiveDataTable caption="ELR reference library" columns={columns} data={elrs} emptyDescription="No ELR references are available." error={error}
      initialSort={{ key: "elr", direction: "asc" }} loading={loading} onRetry={loadElrs} pageSize={20} pageSizeOptions={[20, 50, 100]}
      showCount={false} showExport={false} showFilters={false} showSearch searchPlaceholder="Search ELRs" title="ELR reference library" />
  </>);
};
export default ActiveElrs;
